import { combineReducers } from '@reduxjs/toolkit';
import { composeStoreInitializer } from '@beef/redux';
import { useSelector } from 'react-redux';
import { layout } from "./slices/layout";
export var shortFooterReducer = combineReducers({
  data: function data() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  tagName: function tagName() {
    var _tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'footer';
    return _tagName;
  },
  layout: layout
});
export var shortFooterStore = composeStoreInitializer(shortFooterReducer, [], 'shortFooterStore');
export var useAppSelector = useSelector;